import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=679bcce3&scoped=true&"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679bcce3",
  null
  
)

export default component.exports